import { render, staticRenderFns } from "./friends-updates.vue?vue&type=template&id=494c777e"
import script from "./friends-updates.vue?vue&type=script&lang=js"
export * from "./friends-updates.vue?vue&type=script&lang=js"
import style0 from "./friends-updates.vue?vue&type=style&index=0&id=494c777e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports